module.exports = import("https://cdn.jsdelivr.net/npm/three@0.118/build/three.module.js");;